import _ from 'lodash';

export const UPDATE_FORUM_DATA_REQUEST = 'forumData/UPDATE_REQUEST';
export const UPDATE_FORUM_DATA_SUCCESS = 'forumData/UPDATE_SUCCESS';
export const UPDATE_FORUM_DATA_FAILURE = 'forumData/UPDATE_FAILURE';

export const updateForumDataRequest = () => ({ type: UPDATE_FORUM_DATA_REQUEST });
export const updateForumDataSuccess = payload => ({ type: UPDATE_FORUM_DATA_SUCCESS, payload });
export const updateForumDataFailure = () => ({ type: UPDATE_FORUM_DATA_FAILURE });

export function updateForumData(data = {}) {
  return (dispatch, getState, { request }) => {
    dispatch(updateForumDataRequest());
    const promise = request.patch('/_api/forums/this', _.omit(data, ['_id', 'communityId']));

    return promise
      .then(post => dispatch(updateForumDataSuccess(post)))
      .catch(() => dispatch(updateForumDataFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/update-forum-data.js